import ImageUploadField from '../common/ImageUploadField';
import { appendFormValue, appendFiles } from '../../utils/formData';

export default function ConsultantForm({ form, onChange }) {
  const set = (field, value) => onChange({ ...form, [field]: value });

  const setArrayField = (field, value) => {
    const arr = value.split(',').map((s) => s.trim()).filter(Boolean);
    set(field, arr);
  };

  return (
    <div className="form-grid">
      <div className="form-group full">
        <label>Name *</label>
        <input className="input" value={form.name || ''} onChange={(e) => set('name', e.target.value)} required />
      </div>

      <ImageUploadField
        label="Consultant Photo"
        existingUrls={form.existingImage ? [form.existingImage] : []}
        onExistingChange={(urls) => set('existingImage', urls[0] || '')}
        files={form.newImageFiles || []}
        onFilesChange={(files) => set('newImageFiles', files)}
      />

      <div className="form-group">
        <label>Specialization</label>
        <input className="input" value={form.specialization || ''} onChange={(e) => set('specialization', e.target.value)} />
      </div>
      <div className="form-group">
        <label>Experience</label>
        <input className="input" value={form.experience || ''} onChange={(e) => set('experience', e.target.value)} />
      </div>
      <div className="form-group full">
        <label>Qualifications</label>
        <input className="input" value={form.qualifications || ''} onChange={(e) => set('qualifications', e.target.value)} />
      </div>
      <div className="form-group full">
        <label>Bio</label>
        <textarea className="input textarea" rows={3} value={form.bio || ''} onChange={(e) => set('bio', e.target.value)} />
      </div>
      <div className="form-group">
        <label>Availability</label>
        <input className="input" value={form.availability || ''} onChange={(e) => set('availability', e.target.value)} />
      </div>
      <div className="form-group">
        <label>Next Available</label>
        <input className="input" value={form.nextAvailable || ''} onChange={(e) => set('nextAvailable', e.target.value)} />
      </div>
      <div className="form-group full">
        <label>Languages (comma separated)</label>
        <input className="input" value={(form.languages || []).join(', ')} onChange={(e) => setArrayField('languages', e.target.value)} />
      </div>
      <div className="form-group checkbox-group">
        <label>
          <input type="checkbox" checked={form.active !== false} onChange={(e) => set('active', e.target.checked)} />
          Active
        </label>
      </div>
    </div>
  );
}

export const emptyConsultantForm = {
  name: '',
  existingImage: '',
  newImageFiles: [],
  specialization: '',
  qualifications: '',
  experience: '',
  bio: '',
  availability: '',
  nextAvailable: '',
  languages: [],
  active: true,
};

export function consultantToForm(consultant) {
  if (!consultant) return { ...emptyConsultantForm };
  return {
    name: consultant.name || '',
    existingImage: consultant.image || '',
    newImageFiles: [],
    specialization: consultant.specialization || '',
    qualifications: consultant.qualifications || '',
    experience: consultant.experience || '',
    bio: consultant.bio || '',
    availability: consultant.availability || '',
    nextAvailable: consultant.nextAvailable || '',
    languages: consultant.languages || [],
    active: consultant.active !== false,
  };
}

export function formToConsultantFormData(form) {
  const formData = new FormData();

  appendFormValue(formData, 'name', form.name);
  appendFormValue(formData, 'specialization', form.specialization);
  appendFormValue(formData, 'qualifications', form.qualifications);
  appendFormValue(formData, 'experience', form.experience);
  appendFormValue(formData, 'bio', form.bio);
  appendFormValue(formData, 'availability', form.availability);
  appendFormValue(formData, 'nextAvailable', form.nextAvailable);
  appendFormValue(formData, 'languages', form.languages || []);
  appendFormValue(formData, 'active', form.active);
  appendFormValue(formData, 'existingImage', form.existingImage || '');
  appendFiles(formData, 'image', form.newImageFiles || []);

  return formData;
}
